import { useParams } from 'react-router-dom';
import keys from './keys';
import useApiQuery from '../../../useApiQuery';

const useGetMarketplaceShowProfiles = ({ showId: showIdParam, disabled } = {}) => {
  const { showId: currentShowId } = useParams();
  const showId = showIdParam || currentShowId;

  const query = useApiQuery({
    queryKey: keys.showProfiles({ showId }),
    requestUrl: `/shows/${showId}/marketplace/profiles`,
    disabled: disabled || !showId,
  });

  return {
    showProfiles: query.data,
    showProfilesError: query.error,
    isShowProfilesFetchError: query.isError,
    isShowProfilesFetchSuccess: query.isSuccess,
    isShowProfilesFetching: query.isFetching,
    isShowProfilesLoading: query.isInitialLoading,
    refetchShowProfiles: query.refetch,
    ...query,
  };
};

export default useGetMarketplaceShowProfiles;
